<!-- Click outside to close context menu -->
<div class="context-menu-overlay" *ngIf="layerContextMenu.visible" (click)="hideLayerContextMenu()"></div>

<!-- NHAI GIS Shell -->
<div class="nhai-root">
<!-- NHAI GIS Highway Management System - Top Bar -->
<div class="nhai-header">
  <div class="nhai-header-top">
    <h1 class="nhai-title"> SigmatConflux GIS Management System</h1>
    <div  *ngIf="false" class="nhai-user-actions">
      <span class="nhai-status-dots">
        <span class="dot dot-blue"></span>
        <span class="dot dot-pink"></span>
        <span class="dot dot-green"></span>
      </span>
      <button class="nhai-icon-btn" title="Profile"><span class="icon">👤</span></button>
      <button class="nhai-icon-btn" title="Menu"><span class="icon">☰</span></button>
    </div>
  </div>
  <div class="nhai-tabs">
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'dashboard'" (click)="nhaiActiveModule = 'dashboard'">Dashboard</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'prebid'" (click)="nhaiActiveModule = 'prebid'">Pre-Bid</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'bidding'" (click)="nhaiActiveModule = 'bidding'">Bidding</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'survey'" (click)="nhaiActiveModule = 'survey'">Survey</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'planning'" (click)="nhaiActiveModule = 'planning'">Planning</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'execution'" (click)="nhaiActiveModule = 'execution'">Execution</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'qa'" (click)="nhaiActiveModule = 'qa'">QA</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'billing'" (click)="nhaiActiveModule = 'billing'">Billing</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'row'" (click)="nhaiActiveModule = 'row'">ROW</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'om'" (click)="nhaiActiveModule = 'om'">O&amp;M</button>

    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'editor'" (click)="nhaiActiveModule = 'editor'">Editor</button>
    <button class="nhai-tab" [class.active]="nhaiActiveModule === 'roadplanning'" (click)="nhaiActiveModule = 'roadplanning'">Road Plan</button>
  </div>
  <div class="nhai-toolbar">
    <button class="nhai-toolbar-btn">View Parcels ▾</button>
    <button class="nhai-toolbar-btn">Compensation ▾</button>
    <button class="nhai-toolbar-btn">Permissions</button>
    <button class="nhai-toolbar-btn">Disputes ▾</button>
    <input type="text" class="nhai-search" id="nhaiSearchInput" placeholder="Search..." title="Search features (Enter)" />
    <button type="button" class="nhai-toolbar-btn" id="nhaiFilterBtn" title="Advanced filter / search">Filter ▾</button>
    <button type="button" class="nhai-toolbar-btn" id="nhaiExportBtn" title="Export map data">Export ▾</button>
    <button type="button" class="nhai-toolbar-btn" id="nhaiTakeImageBtn" title="3D Take Image">📷 3D Take Image</button>
    <button type="button" class="nhai-toolbar-btn" id="nhaiPrintBtn" title="Print map layout">Print ▾</button>
    <button type="button" class="nhai-toolbar-btn" id="nhaiReportsBtn" title="Project reports">Reports ▾</button>
  </div>
</div>

<!-- Project Details Header -->
<div *ngIf="showProjectDetails" class="project-details-header">
  <div class="project-details-container">
    <div class="project-info">
      <div class="project-title">
        <h2>{{ projectData?.project_name || 'Loading...' }}</h2>
        <button class="close-btn" (click)="closeProjectDetails()" title="Close Project Details">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div *ngIf="isLoadingProject" class="loading-indicator">
        <div class="spinner"></div>
        <span>Loading project details...</span>
      </div>
      
      <div *ngIf="!isLoadingProject && projectData" class="project-details-grid">
        <div *ngIf="false" class="detail-item">
          <span class="label">Project Code:</span>
          <span class="value">{{ projectData.project_code || 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Status:</span>
          <span class="value" [ngClass]="'status-' + (projectData.stage || 'unknown')">{{ projectData.stage || 'N/A' }}
          </span>
        </div>
        <div class="detail-item">
          <span class="label">Start Date:</span>
          <span class="value">{{ projectData.start_date ? (projectData.start_date | date:'mediumDate') : 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">End Date:</span>
          <span class="value">{{ projectData.end_date ? (projectData.end_date | date:'mediumDate') : 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Budget:</span>
          <span class="value">{{ projectData.budget_amount
 ? (projectData.budget_amount | currency:'INR':'symbol':'1.0-0') : 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Assigned To:</span>
          <span class="value">{{ projectData.assigned_staff_name || 'Not Assigned' | titlecase}}</span>
        </div>
        <div *ngIf="projectData?.client_first_name && projectData?.client_last_name" class="detail-item">
          <span class="label">Owner:</span>
          <span class="value">{{ projectData.client_first_name + ' ' + projectData.client_last_name || 'N/A' }}</span>
        </div>
        <div *ngIf="projectData?.description" class="detail-item full-width">
          <span class="label">Description:</span>
          <span class="value">{{ projectData.description || 'No description available' }}</span>
        </div>
      </div>
      
      <!-- Location Data Section -->
      <div *ngIf="!isLoadingProject && projectData && projectData.location" class="location-section">
        <h3 class="location-title">
          <svg class="location-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          Project Location
        </h3>
        <div class="location-grid">
          <div class="location-item">
            <span class="location-label">Coordinates:</span>
            <span class="location-value clickable-coordinates" (click)="centerMapOnProjectLocation(projectData.location)" title="Click to center map on this location">
              {{ projectData.location.lat }}, {{ projectData.location.long }}
            </span>
          </div>
          <div class="location-item">
            <span class="location-label">City:</span>
            <span class="location-value">{{ projectData.location.city || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">State:</span>
            <span class="location-value">{{ projectData.location.state || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Country:</span>
            <span class="location-value">{{ projectData.location.country || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Pincode:</span>
            <span class="location-value">{{ projectData.location.pincode || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Khasra No:</span>
            <span class="location-value">{{ projectData.location.khasra_no || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <span class="location-label">Area:</span>
            <span class="location-value">{{ projectData.location.area || 'N/A' }}</span>
          </div>
          <div class="location-item full-width">
            <span class="location-label">Address Line 1:</span>
            <span class="location-value">{{ projectData.location.address_line_1 || 'N/A' }}</span>
          </div>
          <div class="location-item full-width" *ngIf="projectData.location.address_line_2">
            <span class="location-label">Address Line 2:</span>
            <span class="location-value">{{ projectData.location.address_line_2 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="false" class="header">
  <h1> Enhanced GIS Editor</h1>
  <div class="project-selector">
    <label>Project:</label>
    <select id="projectSelect">
      <option value="NH44_Delhi_Mumbai">NH-44 Delhi-Mumbai</option>
      <option value="SH15_Pune_Nashik">SH-15 Pune-Nashik</option>
      <option value="MDR23_Rural_Connect">MDR-23 Rural Connect</option>
    </select>
    <button class="btn" id="settingsBtn">⚙️ Settings</button>
  </div>
</div>

<!-- NHAI Body: layout + table + footer -->
<div
  #nhaiBody
  class="nhai-body"
  [class.nhai-body--hidden]="nhaiActiveModule === 'roadplanning'"
  [class.nhai-body--machine-detail-open]="nhaiActiveModule === 'execution' && !!selectedMachine"
  [class.nhai-body--no-bottom]="nhaiActiveModule === 'execution' && !selectedMachine"
  [class.nhai-body--bottom-collapsed]="bottomPanelCollapsed"
>
<!-- NHAI Main Layout -->
<div
  #nhaiLayout
  class="nhai-layout"
  [class.nhai-layout--execution]="nhaiActiveModule === 'execution'"
  [class.nhai-layout--editor]="nhaiActiveModule === 'editor'"
  [class.nhai-layout--two-column]="isMapWideLayout()"
>
  <div class="nhai-left-panel" [class.nhai-workbench--execution]="nhaiActiveModule === 'execution'">
    <ng-container [ngSwitch]="nhaiActiveModule">
      <!-- ROW -->
      <ng-container *ngSwitchCase="'row'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">ROW Workflow ▾</h3>
          <nav class="nhai-workflow-nav">
            <a class="nhai-nav-item active">Land Parcels ▾</a>
            <a class="nhai-nav-item">Compensation</a>
            <a class="nhai-nav-item">Permissions</a>
            <a class="nhai-nav-item">Utility Relocation</a>
            <a class="nhai-nav-item">Disputes ›</a>
            <a class="nhai-nav-item">Land Reports</a>
          </nav>
        </div>
        <div class="nhai-panel-section nhai-acquisition-card">
          <h3 class="nhai-panel-title">Acquisition Status</h3>
          <p class="nhai-acquisition-value">INR 62 Crore</p>
          <div class="nhai-donut-placeholder">
            <span class="nhai-donut-value">66%</span>
          </div>
          <div class="nhai-legend">
            <span class="nhai-legend-item"><i class="dot green"></i> Owned 65% ₹4.0 Cr</span>
            <span class="nhai-legend-item"><i class="dot yellow"></i> Under Process ₹1.6 Cr</span>
            <span class="nhai-legend-item"><i class="dot red"></i> Pending/Disputed ₹0.7 Cr</span>
          </div>
        </div>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Land Parcel Records</h3>
          <p class="nhai-summary">Owned 65% | ₹4.80 Cr</p>
          <p class="nhai-summary">Under Process ₹1.70 Ha</p>
          <p class="nhai-summary">Pending/Disputed ₹1.50 Ha</p>
          <button class="nhai-view-btn">⊕ View List</button>
          <button class="nhai-view-btn">View List</button>
        </div>
      </ng-container>

      <!-- Execution -->
      <ng-container *ngSwitchCase="'execution'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Machine Tracking ▾</h3>
          <nav class="nhai-workflow-nav">
            <a class="nhai-nav-item active">Active Machines</a>
            <a class="nhai-nav-item">Under Construction</a>
            <a class="nhai-nav-item">Completed Area</a>
            <a class="nhai-nav-item">Machine Logs</a>
            <a class="nhai-nav-item">Maintenance</a>
          </nav>
        </div>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Machine Detail</h3>
          <div *ngIf="selectedMachine; else execDetailEmpty">
            <div class="nhai-detail-row"><span class="label">Machine ID:</span> {{ selectedMachine.id }}</div>
            <div class="nhai-detail-row"><span class="label">Type:</span> {{ selectedMachine.type }}</div>
            <div class="nhai-detail-row"><span class="label">Model:</span> {{ selectedMachine.model }}</div>
            <div class="nhai-detail-row"><span class="label">Chainage:</span> {{ selectedMachine.chainage }}</div>
            <div class="nhai-detail-row"><span class="label">Status:</span> <span class="status-owned">{{ (selectedMachine.status || 'active') | titlecase }}</span></div>
          </div>
          <ng-template #execDetailEmpty>
            <div class="nhai-detail-row"><span class="label">Tip:</span> Tap a machine on map</div>
            <div class="nhai-detail-row"><span class="label">Status:</span> <span class="status-process">Tracking Enabled</span></div>
          </ng-template>
        </div>
        <div class="nhai-panel-section nhai-acquisition-card">
          <h3 class="nhai-panel-title">Today Summary</h3>
          <p class="nhai-acquisition-value">12 Machines</p>
          <div class="nhai-legend">
            <span class="nhai-legend-item"><i class="dot green"></i> Active 6</span>
            <span class="nhai-legend-item"><i class="dot yellow"></i> Idle 3</span>
            <span class="nhai-legend-item"><i class="dot red"></i> Down 3</span>
          </div>
        </div>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Segment Progress</h3>
          <p class="nhai-summary">CH 115+000 → CH 119+800: Completed</p>
          <p class="nhai-summary">CH 119+800 → CH 125+400: Under Construction</p>
          <p class="nhai-summary">CH 125+400 → CH 150+000: Planned</p>
          <button class="nhai-view-btn">View Machines</button>
        </div>
      </ng-container>

      <!-- Editor -->
      <ng-container *ngSwitchCase="'editor'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Editor ▾</h3>
          <nav class="nhai-workflow-nav">
            <a class="nhai-nav-item active">Layers</a>
            <a class="nhai-nav-item">Draw</a>
            <a class="nhai-nav-item">Analysis</a>
            <a class="nhai-nav-item">Import / Export</a>
          </nav>
        </div>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Quick Tips</h3>
          <p class="nhai-summary">Use Draw tools to digitize features.</p>
          <p class="nhai-summary">Right-click layer for style/lock/export.</p>
        </div>
      </ng-container>

      <!-- Default (Dashboard/Prebid/Bidding/Survey/Planning/QA/Billing/O&M) -->
      <ng-container *ngSwitchDefault>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">{{ nhaiActiveModule | titlecase }} ▾</h3>
          <nav class="nhai-workflow-nav">
            <a class="nhai-nav-item active">Overview</a>
            <a class="nhai-nav-item">Reports</a>
            <a class="nhai-nav-item">Tasks</a>
            <a class="nhai-nav-item">Notifications</a>
          </nav>
        </div>
        <div class="nhai-panel-section nhai-acquisition-card">
          <h3 class="nhai-panel-title">Status</h3>
          <p class="nhai-acquisition-value">In Progress</p>
          <div class="nhai-legend">
            <span class="nhai-legend-item"><i class="dot green"></i> On Track</span>
            <span class="nhai-legend-item"><i class="dot yellow"></i> Watch</span>
            <span class="nhai-legend-item"><i class="dot red"></i> Blocked</span>
          </div>
        </div>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Quick Actions</h3>
          <button class="nhai-view-btn">Open Summary</button>
          <button class="nhai-view-btn">View List</button>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="nhai-center">
<app-gisavieditor></app-gisavieditor>
  </div>

  <!-- NHAI Right Panel (module-specific) -->
  <div
    class="nhai-right-panel"
    [class.nhai-workbench--execution]="nhaiActiveModule === 'execution'"
    *ngIf="!rightPanelCollapsed && nhaiActiveModule !== 'execution' && nhaiActiveModule !== 'editor'"
  >
    <ng-container [ngSwitch]="nhaiActiveModule">
      <!-- ================= EXECUTION ================= -->
      <ng-container *ngSwitchCase="'execution'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Machine Detail ⋮</h3>
          <div *ngIf="selectedMachine; else execEmpty">
            <div class="nhai-detail-row"><span class="label">Machine ID:</span> {{ selectedMachine.id }}</div>
            <div class="nhai-detail-row"><span class="label">Type:</span> {{ selectedMachine.type }}</div>
            <div class="nhai-detail-row"><span class="label">Model:</span> {{ selectedMachine.model }}</div>
            <div class="nhai-detail-row"><span class="label">Chainage:</span> {{ selectedMachine.chainage }}</div>
            <div class="nhai-detail-row" *ngIf="selectedMachine.telemetry"><span class="label">Telemetry:</span> {{ selectedMachine.telemetry }}</div>
            <div class="nhai-detail-row"><span class="label">Status:</span> <span class="status-owned">{{ (selectedMachine.status || 'active') | titlecase }}</span></div>
          </div>
          <ng-template #execEmpty>
            <div class="nhai-detail-row"><span class="label">Tip:</span> Tap a machine on map</div>
            <div class="nhai-detail-row"><span class="label">Status:</span> <span class="status-process">Tracking Enabled</span></div>
          </ng-template>
        </div>

        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Live Summary</h4>
          <div class="nhai-detail-row"><span class="label">Active:</span> 6</div>
          <div class="nhai-detail-row"><span class="label">Idle:</span> 3</div>
          <div class="nhai-detail-row"><span class="label">Down:</span> 3</div>
          <div class="nhai-detail-row"><span class="label">Last Sync:</span> 2 min ago</div>
        </div>

        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Segment Status</h4>
          <div class="nhai-status-item"><span class="icon ok">✓</span> CH 115+000 → CH 119+800 <span class="badge badge-granted">Completed</span></div>
          <div class="nhai-status-item"><span class="icon pending">!</span> CH 119+800 → CH 125+400 <span class="badge badge-pending">Under Construction</span></div>
          <div class="nhai-status-item"><span class="icon pending">!</span> CH 125+400 → CH 150+000 <span class="badge badge-pending">Planned</span></div>
        </div>
      </ng-container>

      <!-- ================= ROW ================= -->
      <ng-container *ngSwitchCase="'row'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Parcel Details ⋮</h3>
          <div class="nhai-detail-row"><span class="label">Parcel ID:</span> LP-0456</div>
          <div class="nhai-detail-row"><span class="label">Owner:</span> S. Kumar</div>
          <div class="nhai-detail-row"><span class="label">Area:</span> 0.85 Ha</div>
          <div class="nhai-detail-row"><span class="label">Status:</span> Pending</div>
          <div class="nhai-detail-row"><span class="label">Compensation:</span> —</div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Document Status</h4>
          <div class="nhai-status-item"><span class="icon ok">✓</span> DC Agreement</div>
          <div class="nhai-status-item"><span class="icon pending">!</span> In Forest Clearance <span class="badge badge-pending">Pending</span></div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Gov't Permissions</h4>
          <div class="nhai-status-item"><span class="icon warning">⊘</span> Forest Clearance <span class="badge badge-pending">Pending</span></div>
          <div class="nhai-status-item"><span class="icon ok">✓</span> Utility Relocation <span class="badge badge-granted">Granted</span></div>
        </div>
      </ng-container>

      <!-- ================= BILLING ================= -->
      <ng-container *ngSwitchCase="'billing'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">Billing Summary ⋮</h3>
          <div class="nhai-detail-row"><span class="label">Contract:</span> EPC-04 / NH-44</div>
          <div class="nhai-detail-row"><span class="label">This Month:</span> ₹3.2 Cr</div>
          <div class="nhai-detail-row"><span class="label">Approved:</span> ₹2.1 Cr</div>
          <div class="nhai-detail-row"><span class="label">Pending:</span> ₹1.1 Cr</div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Latest Bills</h4>
          <div class="nhai-status-item"><span class="icon ok">✓</span> RA-12 <span class="badge badge-granted">Approved</span></div>
          <div class="nhai-status-item"><span class="icon pending">!</span> RA-13 <span class="badge badge-pending">Pending</span></div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Actions</h4>
          <button class="nhai-view-btn">Create Bill</button>
          <button class="nhai-view-btn">Export Summary</button>
        </div>
      </ng-container>

      <!-- ================= QA ================= -->
      <ng-container *ngSwitchCase="'qa'">
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">QA Snapshot ⋮</h3>
          <div class="nhai-detail-row"><span class="label">Open NCR:</span> 4</div>
          <div class="nhai-detail-row"><span class="label">Tests Today:</span> 18</div>
          <div class="nhai-detail-row"><span class="label">Pass Rate:</span> 92%</div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Recent Checks</h4>
          <div class="nhai-status-item"><span class="icon ok">✓</span> Compaction Test <span class="badge badge-granted">Pass</span></div>
          <div class="nhai-status-item"><span class="icon pending">!</span> Core Cut <span class="badge badge-pending">Review</span></div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Actions</h4>
          <button class="nhai-view-btn">Log Test</button>
          <button class="nhai-view-btn">View NCR</button>
        </div>
      </ng-container>

      <!-- ================= DEFAULT (Dashboard/Prebid/Bidding/Survey/Planning/O&M/Editor) ================= -->
      <ng-container *ngSwitchDefault>
        <div class="nhai-panel-section">
          <h3 class="nhai-panel-title">{{ nhaiActiveModule | titlecase }} Panel ⋮</h3>
          <div class="nhai-detail-row"><span class="label">Status:</span> In Progress</div>
          <div class="nhai-detail-row"><span class="label">Owner:</span> Project Team</div>
          <div class="nhai-detail-row"><span class="label">Updated:</span> Today</div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Quick Links</h4>
          <div class="nhai-status-item"><span class="icon ok">✓</span> Reports</div>
          <div class="nhai-status-item"><span class="icon pending">!</span> Tasks <span class="badge badge-pending">3</span></div>
        </div>
        <div class="nhai-panel-section">
          <h4 class="nhai-subtitle">Actions</h4>
          <button class="nhai-view-btn">Open Summary</button>
          <button class="nhai-view-btn">View List</button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- NHAI Bottom Table -->
<div
  class="nhai-bottom-section"
  [class.nhai-bottom-section--execution]="nhaiActiveModule === 'execution'"
  *ngIf="nhaiActiveModule !== 'execution' || !!selectedMachine"
>
  <div class="nhai-table-header">
    <div class="nhai-table-header-title">
      <h3 *ngIf="nhaiActiveModule === 'row'">Land Parcel Records</h3>
      <h3 *ngIf="nhaiActiveModule === 'execution'">Machine Activity Log</h3>
      <h3 *ngIf="nhaiActiveModule !== 'row' && nhaiActiveModule !== 'execution'">Module Records</h3>
      <button
        type="button"
        class="nhai-table-collapse-btn"
        *ngIf="nhaiActiveModule !== 'execution' && nhaiActiveModule !== 'editor'"
        (click)="toggleRightPanel()"
      >
        {{ rightPanelCollapsed ? 'Show side panel' : 'Full-width map' }}
      </button>
      <button type="button" class="nhai-table-collapse-btn" (click)="toggleBottomPanel()">
        {{ bottomPanelCollapsed ? 'Show records' : 'Maximize map' }}
      </button>
    </div>
    <div class="nhai-table-summary" *ngIf="nhaiActiveModule === 'row'">
      <span>Owned 0.5 Ha</span>
      <span>Under Process 2.1,70 Ha</span>
      <span>Pending/Disputed 2.1,50 Ha</span>
    </div>
    <div class="nhai-table-summary" *ngIf="nhaiActiveModule === 'execution'">
      <span>Active 6</span>
      <span>Idle 3</span>
      <span>Down 3</span>
    </div>
    <div class="nhai-table-summary" *ngIf="nhaiActiveModule !== 'row' && nhaiActiveModule !== 'execution'">
      <span>Status: In Progress</span>
      <span>Updated: Today</span>
    </div>
  </div>
  <div class="nhai-table-scroll">
    <!-- ROW table -->
    <table class="nhai-data-table" *ngIf="nhaiActiveModule === 'row'">
      <thead>
        <tr>
          <th><input type="checkbox"></th>
          <th>Parcel ID</th>
          <th>Owner</th>
          <th>Area</th>
          <th>Status</th>
          <th>Compensation</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr><td><input type="checkbox"></td><td>LP-0452</td><td>R. Sharma</td><td>0.75 Ha</td><td><span class="status-owned">Owned</span></td><td>₹10,50,000</td><td><button class="nhai-btn-sm">View</button></td></tr>
        <tr><td><input type="checkbox"></td><td>LP-0453</td><td>A. Verma</td><td>1.20 Ha</td><td><span class="status-process">Under Process</span></td><td>₹18,00,000</td><td><button class="nhai-btn-sm">View</button></td></tr>
      </tbody>
    </table>

    <!-- Execution table -->
    <table class="nhai-data-table" *ngIf="nhaiActiveModule === 'execution'">
      <thead>
        <tr>
          <th><input type="checkbox"></th>
          <th>Machine ID</th>
          <th>Type</th>
          <th>Chainage</th>
          <th>Status</th>
          <th>Last Update</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr><td><input type="checkbox"></td><td>CHN48-EX-102</td><td>Excavator</td><td>CH 119+800</td><td><span class="status-owned">Active</span></td><td>2 min ago</td><td><button class="nhai-btn-sm">Track</button></td></tr>
        <tr><td><input type="checkbox"></td><td>CHN48-LD-205</td><td>Loader</td><td>CH 121+250</td><td><span class="status-process">Idle</span></td><td>7 min ago</td><td><button class="nhai-btn-sm">Track</button></td></tr>
      </tbody>
    </table>

    <!-- Default table -->
    <table class="nhai-data-table" *ngIf="nhaiActiveModule !== 'row' && nhaiActiveModule !== 'execution'">
      <thead>
        <tr>
          <th><input type="checkbox"></th>
          <th>Record ID</th>
          <th>Title</th>
          <th>Owner</th>
          <th>Status</th>
          <th>Updated</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr><td><input type="checkbox"></td><td>{{ nhaiActiveModule | uppercase }}-001</td><td>Summary Report</td><td>System</td><td><span class="status-process">In Progress</span></td><td>Today</td><td><button class="nhai-btn-sm">Open</button></td></tr>
        <tr><td><input type="checkbox"></td><td>{{ nhaiActiveModule | uppercase }}-002</td><td>Daily Log</td><td>Team</td><td><span class="status-owned">Ready</span></td><td>Yesterday</td><td><button class="nhai-btn-sm">Open</button></td></tr>
      </tbody>
    </table>
  </div>
  <div class="nhai-table-footer">
    <span *ngIf="nhaiActiveModule === 'row'">Total: 6 Parcels ₹83,90,000</span>
    <span *ngIf="nhaiActiveModule === 'execution'">Total: 12 Machines (6 Active)</span>
    <span *ngIf="nhaiActiveModule !== 'row' && nhaiActiveModule !== 'execution'">Total: 2 Records</span>
  </div>
</div>

<!-- NHAI Footer -->
<div class="nhai-footer">
  <span>📍 Lat: 19.1234 Lon: 72.9876</span>
  <span>⛓ Chainage: 120+750</span>
  <span>⛰ Elevation: 85 m</span>
  <span>📐 Scale: 1:5000</span>
</div>
</div>

<!-- ======================== ROAD PLANNING MODULE ======================== -->
<div class="rp-root" *ngIf="nhaiActiveModule === 'roadplanning'">

  <!-- RP Toolbar Row (pill-shaped buttons matching reference) -->
  <div class="rp-toolbar">
    <div class="rp-toolbar-left">
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'select'" (click)="rpSetTool('select')">
        <span class="rp-tb-icon">&#9745;</span> Select <span class="rp-tb-arrow">&#9662;</span>
      </button>
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'draw'" (click)="rpSetTool('draw')">
        <span class="rp-tb-icon">&#9998;</span> Draw <span class="rp-tb-arrow">&#9662;</span>
      </button>
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'edit'" (click)="rpSetTool('edit')">
        <span class="rp-tb-icon">&#9997;</span> Edit <span class="rp-tb-arrow">&#9662;</span>
      </button>
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'snap'" (click)="rpSetTool('snap')">
        <span class="rp-tb-icon">&#128204;</span> Snap
      </button>
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'measure'" (click)="rpSetTool('measure')">
        <span class="rp-tb-icon">&#128207;</span> Measure <span class="rp-tb-arrow">&#9662;</span>
      </button>
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'chainage'" (click)="rpSetTool('chainage')">
        <span class="rp-tb-icon">&#9898;</span> Chainage
      </button>
      <button class="rp-tb-btn" [class.active]="rpActiveTool === 'xsection'" (click)="rpSetTool('xsection')">
        <span class="rp-tb-icon">&#10010;</span> X-Section
      </button>
    </div>
    <div class="rp-toolbar-right">
      <button class="rp-tb-btn" (click)="rpSetTool('shoulder')">
        <span class="rp-tb-icon">&#9960;</span> Shoulder
      </button>
      <button class="rp-tb-btn" (click)="rpSetTool('separator')">
        <span class="rp-tb-icon">&#9646;</span> Median
      </button>
      <button class="rp-tb-btn rp-tb-danger" [class.active]="rpActiveTool === 'delete'" (click)="rpSetTool('delete')">
        <span class="rp-tb-icon">&#128465;</span> Delete
      </button>
      <span class="rp-tb-divider"></span>
      <button class="rp-tb-btn" title="Import Data">
        <span class="rp-tb-icon">&#128229;</span> Import <span class="rp-tb-arrow">&#9662;</span>
      </button>
      <button class="rp-tb-btn" title="Export / Reports">
        <span class="rp-tb-icon">&#128203;</span> Reports <span class="rp-tb-arrow">&#9662;</span>
      </button>
    </div>
  </div>

  <!-- RP Main Content: 3-column layout -->
  <div class="rp-main">

    <!-- RP Left Sidebar (Accordion style matching reference "Project Workflow") -->
    <div class="rp-sidebar" [class.rp-sidebar--collapsed]="rpSidebarCollapsed">
      <div class="rp-sidebar-header">
        <span class="rp-sidebar-title" *ngIf="!rpSidebarCollapsed">Road Planning Workflow</span>
        <button class="rp-sidebar-collapse" (click)="rpSidebarCollapsed = !rpSidebarCollapsed">
          {{ rpSidebarCollapsed ? '&#9776;' : '&#9664;' }}
        </button>
      </div>

      <div class="rp-accordion" *ngIf="!rpSidebarCollapsed">
        <!-- Accordion: Road Design -->
        <div class="rp-acc-item" [class.expanded]="rpAccordion.design">
          <button class="rp-acc-header" (click)="rpAccordion.design = !rpAccordion.design">
            <span class="rp-acc-icon">&#9998;</span>
            <span class="rp-acc-label">Road Design</span>
            <span class="rp-acc-arrow">{{ rpAccordion.design ? '&#9660;' : '&#9654;' }}</span>
          </button>
          <div class="rp-acc-body" *ngIf="rpAccordion.design">
            <button class="rp-nav-item" [class.active]="rpActiveTool === 'draw'" (click)="rpSetTool('draw')">
              <span class="rp-nav-dot rp-dot-blue"></span> Draw Alignment
            </button>
            <button class="rp-nav-item" [class.active]="rpActiveTool === 'shoulder'" (click)="rpSetTool('shoulder')">
              <span class="rp-nav-dot rp-dot-green"></span> Shoulders
            </button>
            <button class="rp-nav-item" [class.active]="rpActiveTool === 'separator'" (click)="rpSetTool('separator')">
              <span class="rp-nav-dot rp-dot-yellow"></span> Median / Separator
            </button>
          </div>
        </div>

        <!-- Accordion: Chainage & Stations -->
        <div class="rp-acc-item" [class.expanded]="rpAccordion.chainage">
          <button class="rp-acc-header" (click)="rpAccordion.chainage = !rpAccordion.chainage">
            <span class="rp-acc-icon">&#9898;</span>
            <span class="rp-acc-label">Chainage & Stations</span>
            <span class="rp-acc-arrow">{{ rpAccordion.chainage ? '&#9660;' : '&#9654;' }}</span>
          </button>
          <div class="rp-acc-body" *ngIf="rpAccordion.chainage">
            <button class="rp-nav-item" [class.active]="rpActiveTool === 'chainage'" (click)="rpSetTool('chainage')">
              <span class="rp-nav-dot rp-dot-blue"></span> Generate Chainage
            </button>
            <button class="rp-nav-item" [class.active]="rpActiveTool === 'xsection'" (click)="rpSetTool('xsection')">
              <span class="rp-nav-dot rp-dot-red"></span> Cross-Sections
            </button>
          </div>
        </div>

        <!-- Accordion: Layers -->
        <div class="rp-acc-item" [class.expanded]="rpAccordion.layers">
          <button class="rp-acc-header" (click)="rpAccordion.layers = !rpAccordion.layers">
            <span class="rp-acc-icon">&#128450;</span>
            <span class="rp-acc-label">Layers</span>
            <span class="rp-acc-arrow">{{ rpAccordion.layers ? '&#9660;' : '&#9654;' }}</span>
          </button>
          <div class="rp-acc-body" *ngIf="rpAccordion.layers">
            <div class="rp-layers-panel">
              <div class="rp-layers-viz-row" role="group" aria-label="Visualization mode">
                <button type="button" class="rp-layers-viz-btn" [class.active]="rpVisualizationMode === 'terrain'"
                        (click)="rpSetVisualizationMode('terrain')">Terrain</button>
                <button type="button" class="rp-layers-viz-btn" [class.active]="rpVisualizationMode === 'design'"
                        (click)="rpSetVisualizationMode('design')">Design</button>
              </div>
              <div class="layer-search-wrap">
                <span class="layer-search-wrap__icon" aria-hidden="true">🔍</span>
                <input
                  type="search"
                  [(ngModel)]="rpLayerSearchTerm"
                  class="layer-search-input"
                  placeholder="Filter layers…"
                  aria-label="Filter layers">
                <button
                  type="button"
                  class="layer-search-clear"
                  *ngIf="rpLayerSearchTerm"
                  (click)="rpClearLayerSearch()"
                  title="Clear filter"
                  aria-label="Clear filter">×</button>
              </div>
              <div class="drawing-target-hint" title="Active sketch target — select a construction layer to change">
                <span class="drawing-target-hint__label">Draw on</span>
                <strong class="drawing-target-hint__value">{{ getRpDrawingTargetLabel() }}</strong>
              </div>
              <div class="layer-groups-container">
                <div
                  *ngFor="let groupEntry of getRpLayerGroups()"
                  class="layer-group-item"
                  [class.expanded]="isRpGroupExpanded(groupEntry.name)">
                  <div class="group-header" (click)="toggleRpGroupExpanded(groupEntry.name)">
                    <span class="group-toggle-icon">{{ isRpGroupExpanded(groupEntry.name) ? '▼' : '▶' }}</span>
                    <span class="group-name">{{ groupEntry.name }}</span>
                    <span class="group-count">({{ groupEntry.layers.length }})</span>
                  </div>
                  <div class="group-layers" *ngIf="isRpGroupExpanded(groupEntry.name)">
                    <div
                      *ngFor="let layerId of groupEntry.layers"
                      class="layer-item"
                      [class.selected]="rpSelectedLayerId === layerId"
                      [class.layer-item--overlay]="isRpOverlayLayer(layerId)"
                      (click)="rpSelectLayer(layerId)">
                      <div class="layer-row">
                        <div class="layer-controls-left">
                          <label class="layer-visibility-toggle" [title]="rpLayerVisible[layerId] ? 'Hide layer' : 'Show layer'">
                            <input
                              type="checkbox"
                              [checked]="rpLayerVisible[layerId]"
                              [disabled]="layerId === 'osm_nodes' && !rpLayerVisible['osm_roads']"
                              (change)="rpToggleLayer(layerId, $any($event.target).checked)"
                              (click)="$event.stopPropagation()">
                            <span class="checkmark"></span>
                          </label>
                          <span class="layer-icon" aria-hidden="true">{{ getRpLayerIcon(layerId) }}</span>
                          <div class="layer-label-block">
                            <span class="layer-name" [title]="getRpLayerFullLabel(layerId)">{{ getRpLayerDisplayName(layerId) }}</span>
                            <span class="layer-meta" *ngIf="layerId === 'osm_nodes'">Zoom ≥ {{ rpNodesMinZoom }}</span>
                          </div>
                          <span class="layer-count-badge" *ngIf="getRpLayerCount(layerId) != null">{{ getRpLayerCount(layerId) }}</span>
                        </div>
                      </div>
                      <div class="layer-expanded-controls" *ngIf="rpSelectedLayerId === layerId && isRpConstructionLayer(layerId)">
                        <div class="opacity-control">
                          <label>Opacity</label>
                          <input
                            type="range"
                            min="0"
                            max="100"
                            [value]="rpLayerOpacity"
                            (input)="rpOnSelectedLayerOpacityChange(+$any($event.target).value)"
                            (click)="$event.stopPropagation()"
                            class="opacity-slider">
                          <span class="opacity-value">{{ rpLayerOpacity }}%</span>
                        </div>
                      </div>
                      <div class="layer-overlay-detail" *ngIf="rpSelectedLayerId === layerId && isRpOverlayLayer(layerId)">
                        <span class="layer-overlay-detail__text">{{ getRpLayerFullLabel(layerId) }}</span>
                        <span class="layer-overlay-detail__status" *ngIf="rpMapStatus && layerId === 'osm_roads'">{{ rpMapStatus }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="rp-layers-empty" *ngIf="getRpLayerGroups().length === 0">No layers match filter</p>
            </div>

            <div class="rp-seg-divider"></div>
            <div class="rp-seg-title">Segment Progress</div>
            <div class="rp-seg-list">
              <div class="rp-seg-item" *ngFor="let seg of rpSegments">
                <div class="rp-seg-range">{{ seg.from }} &rarr; {{ seg.to }}</div>
                <div class="rp-seg-bar-bg">
                  <div class="rp-seg-bar-fill"
                       [style.width.%]="seg.pct"
                       [class.seg-completed]="seg.status === 'completed'"
                       [class.seg-construction]="seg.status === 'under_construction'"
                       [class.seg-planned]="seg.status === 'planned'"></div>
                </div>
                <span class="rp-seg-pct">{{ seg.pct }}%</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Accordion: Roads -->
        <div class="rp-acc-item" [class.expanded]="rpAccordion.roads">
          <button class="rp-acc-header" (click)="rpAccordion.roads = !rpAccordion.roads">
            <span class="rp-acc-icon">&#128739;</span>
            <span class="rp-acc-label">Roads ({{ rpRoads.length }})</span>
            <span class="rp-acc-arrow">{{ rpAccordion.roads ? '&#9660;' : '&#9654;' }}</span>
          </button>
          <div class="rp-acc-body" *ngIf="rpAccordion.roads">
            <button class="rp-road-item" *ngFor="let road of rpRoads; let i = index"
                    [class.active]="rpSelectedRoadIndex === i"
                    (click)="rpSelectRoad(i)">
              <span class="rp-road-swatch" [style.background]="road.color || '#000'"></span>
              <span class="rp-road-label">{{ road.name || 'Road ' + (i + 1) }}</span>
              <span class="rp-road-badge">{{ road.type }}</span>
            </button>
            <div *ngIf="rpRoads.length === 0" class="rp-empty-msg">No roads drawn yet</div>
          </div>
        </div>

        <!-- Accordion: Survey & Data -->
        <div class="rp-acc-item" [class.expanded]="rpAccordion.survey">
          <button class="rp-acc-header" (click)="rpAccordion.survey = !rpAccordion.survey">
            <span class="rp-acc-icon">&#128225;</span>
            <span class="rp-acc-label">Field Survey</span>
            <span class="rp-acc-arrow">{{ rpAccordion.survey ? '&#9660;' : '&#9654;' }}</span>
          </button>
          <div class="rp-acc-body" *ngIf="rpAccordion.survey">
            <button class="rp-nav-item">
              <span class="rp-nav-dot rp-dot-blue"></span> GPS Track
            </button>
            <button class="rp-nav-item">
              <span class="rp-nav-dot rp-dot-green"></span> Upload Photo
            </button>
            <button class="rp-nav-item">
              <span class="rp-nav-dot rp-dot-yellow"></span> Save Point
            </button>
          </div>
        </div>

        <!-- Accordion: ROW / Land -->
        <div class="rp-acc-item" [class.expanded]="rpAccordion.rowLand">
          <button class="rp-acc-header" (click)="rpAccordion.rowLand = !rpAccordion.rowLand">
            <span class="rp-acc-icon">&#127968;</span>
            <span class="rp-acc-label">ROW / Land</span>
            <span class="rp-acc-arrow">{{ rpAccordion.rowLand ? '&#9660;' : '&#9654;' }}</span>
          </button>
          <div class="rp-acc-body" *ngIf="rpAccordion.rowLand">
            <button class="rp-nav-item">
              <span class="rp-nav-dot rp-dot-blue"></span> View Parcels
            </button>
            <button class="rp-nav-item">
              <span class="rp-nav-dot rp-dot-yellow"></span> Compensation
            </button>
          </div>
        </div>
      </div>

      <!-- Sidebar Bottom: Sync / Connection Status -->
      <div class="rp-sidebar-footer" *ngIf="!rpSidebarCollapsed">
        <button class="rp-sync-btn" [class.offline]="!rpIsOnline" (click)="rpToggleSync()">
          <span class="rp-sync-dot" [class.rp-dot-online]="rpIsOnline" [class.rp-dot-offline]="!rpIsOnline"></span>
          {{ rpIsOnline ? 'Online' : 'Offline' }}
        </button>
      </div>
    </div>

    <!-- RP Map Area (Center) — Multi-Layer Road Visualization -->
    <div class="rp-map-area">
      <div class="rp-map-canvas" id="rpMapCanvas">
        <!-- OpenLayers map: satellite base + OSM road network (iD-style) -->
        <div #rpMapEl class="rp-ol-map" role="region" aria-label="Road planning map"></div>
        <div class="rp-map-status" *ngIf="rpMapStatus">{{ rpMapStatus }}</div>
        <a class="rp-osm-attribution" href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">
          {{ rpOsmAttribution }}
        </a>
      </div>

      <!-- Floating Project Info Card -->
      <div class="rp-project-card">
        <span class="rp-project-pin">&#128205;</span>
        <div class="rp-project-card-body">
          <div class="rp-project-title">{{ rpProjectName }} Road Planning</div>
          <div class="rp-project-meta">
            CH 115+000 to CH 150+000 &#x2022; {{ rpSegments.length }} segments
          </div>
        </div>
        <span class="rp-project-status" [class.rp-status-online]="rpIsOnline"
              [class.rp-status-offline]="!rpIsOnline">
          {{ rpIsOnline ? 'Synced' : 'Local' }}
        </span>
      </div>

      <!-- Layer Visibility Toggle (floating, top-right of map) -->
      <div class="rp-layer-float">
        <div class="rp-lf-title">Layers</div>
        <div class="rp-viz-toggle-wrap">
          <button class="rp-viz-toggle" [class.active]="rpVisualizationMode === 'terrain'" (click)="rpSetVisualizationMode('terrain')">Terrain</button>
          <button class="rp-viz-toggle" [class.active]="rpVisualizationMode === 'design'" (click)="rpSetVisualizationMode('design')">Design</button>
        </div>
        <label class="rp-lf-toggle" [class.active]="rpLayerVisible['planning']">
          <input type="checkbox" [checked]="rpLayerVisible['planning']"
                 (change)="rpToggleLayer('planning', $any($event.target).checked)">
          <span class="rp-lf-swatch" style="background:#2196F3"></span> Planning
        </label>
        <label class="rp-lf-toggle" [class.active]="rpLayerVisible['survey']">
          <input type="checkbox" [checked]="rpLayerVisible['survey']"
                 (change)="rpToggleLayer('survey', $any($event.target).checked)">
          <span class="rp-lf-swatch" style="background:#2ecc71"></span> Survey
        </label>
        <label class="rp-lf-toggle" [class.active]="rpLayerVisible['execution']">
          <input type="checkbox" [checked]="rpLayerVisible['execution']"
                 (change)="rpToggleLayer('execution', $any($event.target).checked)">
          <span class="rp-lf-swatch" style="background:#1a1a1a; border:1px solid #666"></span> Execution
        </label>
      </div>

      <!-- Construction Legend (matching reference) -->
      <div class="rp-const-legend" *ngIf="rpLayerVisible['execution']">
        <div class="rp-cl-item"><span class="rp-cl-sw" style="background:#2ecc71"></span> Active Machines</div>
        <div class="rp-cl-item"><span class="rp-cl-sw" style="background:#f1c40f"></span> Completed Area</div>
        <div class="rp-cl-item"><span class="rp-cl-sw" style="background:#e74c3c"></span> Under Construction</div>
        <div class="rp-cl-item" *ngIf="rpVisualizationMode === 'design'"><span class="rp-cl-sw" style="background:#95a5a6"></span> Existing Road</div>
        <div class="rp-cl-item" *ngIf="rpVisualizationMode === 'design'"><span class="rp-cl-sw" style="background:#f39c12"></span> Alternate Route</div>
        <div class="rp-cl-item" *ngIf="rpVisualizationMode === 'design'"><span class="rp-cl-sw" style="background:#2ecc71"></span> Proposed Alignment</div>
      </div>

      <!-- Design view callouts -->
      <div class="rp-callout rp-callout--left" *ngIf="rpVisualizationMode === 'design'">Tender Analysis</div>
      <div class="rp-callout rp-callout--bottom-left" *ngIf="rpVisualizationMode === 'design'">Survey Data Collection</div>
      <div class="rp-callout rp-callout--top-right" *ngIf="rpVisualizationMode === 'design'">Alignment Design</div>
      <div class="rp-callout rp-callout--bottom-right" *ngIf="rpVisualizationMode === 'design'">Construction Progress</div>

      <!-- Machine Detail Card (matching reference CHN48-EX-102 card) -->
      <div class="rp-machine-card" *ngIf="rpSelectedMachine">
        <div class="rp-mc-header">
          <span class="rp-mc-title">{{ rpSelectedMachine.id }}</span>
          <button class="rp-mc-close" (click)="rpSelectedMachine = null">&#10005;</button>
        </div>
        <div class="rp-mc-body">
          <div class="rp-mc-icon">&#128679;</div>
          <div class="rp-mc-details">
            <div class="rp-mc-row"><span class="rp-mc-label">Model:</span> {{ rpSelectedMachine.model }}</div>
            <div class="rp-mc-row"><span class="rp-mc-label">Type:</span> {{ rpSelectedMachine.type }}</div>
            <div class="rp-mc-row"><span class="rp-mc-label">Location:</span> {{ rpSelectedMachine.chainage }}</div>
            <div class="rp-mc-row"><span class="rp-mc-label">Status:</span> <span class="rp-mc-active">&#9679; Active</span></div>
          </div>
        </div>
      </div>

      <!-- Drawing mode banners -->
      <div class="rp-drawing-banner" *ngIf="rpActiveTool === 'draw'">
        <span>&#9998; Drawing: Tap to place points, double-tap to finish</span>
        <button class="rp-banner-cancel" (click)="rpSetTool('')">Cancel</button>
      </div>
      <div class="rp-drawing-banner rp-banner-xsection" *ngIf="rpActiveTool === 'xsection'">
        <span>&#10010; Tap on map near a road to place cross-section marker</span>
        <button class="rp-banner-cancel" (click)="rpSetTool('')">Cancel</button>
      </div>

      <!-- GPS Indicator -->
      <div class="rp-gps-indicator" (click)="rpCenterOnGps()">
        <span class="rp-gps-icon">&#128752;</span>
        <span class="rp-gps-text">{{ rpGpsStatus }}</span>
        <span class="rp-gps-accuracy" *ngIf="rpGpsAccuracy">&#177; {{ rpGpsAccuracy }}m</span>
      </div>

      <!-- Zoom Controls -->
      <div class="rp-zoom-controls">
        <button class="rp-zoom-btn" (click)="rpZoomIn()" title="Zoom In">+</button>
        <button class="rp-zoom-btn" (click)="rpZoomOut()" title="Zoom Out">&minus;</button>
      </div>

      <!-- Bottom info bar on map -->
      <div class="rp-map-bottom-bar">
        <span>&#128679; Machine Detail</span>
        <span class="rp-mbb-divider">|</span>
        <span><span class="rp-mbb-sw" style="background:#34495e"></span> Active</span>
        <span><span class="rp-mbb-sw" style="background:#f1c40f"></span> Completed</span>
        <span><span class="rp-mbb-sw" style="background:#2ecc71"></span> Concreted Area</span>
        <span class="rp-mbb-divider">|</span>
        <span>&#9788; 32&deg;C Sunny</span>
        <span class="rp-project-status-pill" [class.status-active]="rpIsOnline">
          &#9679; {{ rpIsOnline ? 'Active' : 'Offline' }}
        </span>
      </div>
    </div>

    <!-- RP Right Panel (Contextual - matching reference detail panel) -->
    <div class="rp-right-panel" [class.rp-right-panel--hidden]="!rpRightPanelVisible">
      <div class="rp-right-header">
        <h3 class="rp-right-title">Road Properties <span class="rp-right-dots">&#8942;</span></h3>
      </div>

      <!-- Road Properties Form -->
      <div class="rp-detail-section">
        <div class="rp-detail-row">
          <span class="rp-detail-label">Name</span>
          <input class="rp-detail-input" type="text" placeholder="Enter road name"
                 [value]="rpRoadProps.name"
                 (input)="rpRoadProps.name = $any($event.target).value">
        </div>
        <div class="rp-detail-row">
          <span class="rp-detail-label">Type</span>
          <select class="rp-detail-select" [value]="rpRoadProps.type"
                  (change)="rpOnRoadTypeChange($any($event.target).value)">
            <option value="">-- Select --</option>
            <option *ngFor="let preset of rpRoadPresets" [value]="preset.id">
              {{ preset.label }}
            </option>
          </select>
        </div>
        <div class="rp-detail-row">
          <span class="rp-detail-label">Lanes</span>
          <div class="rp-stepper">
            <button class="rp-stepper-btn" (click)="rpStepLanes(-1)">&minus;</button>
            <span class="rp-stepper-value">{{ rpRoadProps.lanes }}</span>
            <button class="rp-stepper-btn" (click)="rpStepLanes(1)">+</button>
          </div>
        </div>
        <div class="rp-detail-row">
          <span class="rp-detail-label">Lane Width</span>
          <div class="rp-detail-value-unit">
            <input class="rp-detail-input rp-input-sm" type="number" step="0.1" min="2.5" max="5.0"
                   [value]="rpRoadProps.laneWidth"
                   (input)="rpRoadProps.laneWidth = +$any($event.target).value; rpRecalcRow()">
            <span class="rp-unit">m</span>
          </div>
        </div>
        <div class="rp-detail-row">
          <span class="rp-detail-label">Shoulder L</span>
          <div class="rp-detail-value-unit">
            <input class="rp-detail-input rp-input-sm" type="number" step="0.1" min="0"
                   [value]="rpRoadProps.shoulderL"
                   (input)="rpRoadProps.shoulderL = +$any($event.target).value; rpRecalcRow()">
            <span class="rp-unit">m</span>
          </div>
        </div>
        <div class="rp-detail-row">
          <span class="rp-detail-label">Shoulder R</span>
          <div class="rp-detail-value-unit">
            <input class="rp-detail-input rp-input-sm" type="number" step="0.1" min="0"
                   [value]="rpRoadProps.shoulderR"
                   (input)="rpRoadProps.shoulderR = +$any($event.target).value; rpRecalcRow()">
            <span class="rp-unit">m</span>
          </div>
        </div>
        <div class="rp-detail-row" *ngIf="rpRoadProps.lanes >= 4">
          <span class="rp-detail-label">Separator</span>
          <div class="rp-detail-value-unit">
            <input class="rp-detail-input rp-input-sm" type="number" step="0.1" min="0"
                   [value]="rpRoadProps.separator"
                   (input)="rpRoadProps.separator = +$any($event.target).value; rpRecalcRow()">
            <span class="rp-unit">m</span>
          </div>
        </div>
        <div class="rp-detail-row rp-row-highlight">
          <span class="rp-detail-label">ROW</span>
          <span class="rp-detail-value-lg">{{ rpRoadProps.row | number:'1.1-1' }} m</span>
          <span class="rp-detail-auto" *ngIf="!rpRoadProps.rowOverride">(auto)</span>
          <button class="rp-detail-edit-btn" *ngIf="!rpRoadProps.rowOverride"
                  (click)="rpRoadProps.rowOverride = true">&#9998;</button>
        </div>
        <input *ngIf="rpRoadProps.rowOverride" class="rp-detail-input rp-input-sm"
               type="number" step="0.5" min="5"
               [value]="rpRoadProps.row"
               (input)="rpRoadProps.row = +$any($event.target).value"
               style="margin: 0 0 8px 90px; width: 80px;">
        <button class="rp-apply-btn" (click)="rpApplyProperties()">APPLY</button>
      </div>

      <!-- Chainage Section -->
      <div class="rp-right-subheader">
        <h4 class="rp-sub-title">Chainage</h4>
      </div>
      <div class="rp-detail-section">
        <div class="rp-detail-row">
          <span class="rp-detail-label">Interval</span>
          <div class="rp-radio-group">
            <label class="rp-radio-pill" [class.active]="rpChainageInterval === 50">
              <input type="radio" name="rpChainageInterval" [value]="50"
                     [checked]="rpChainageInterval === 50" (change)="rpChainageInterval = 50"> 50m
            </label>
            <label class="rp-radio-pill" [class.active]="rpChainageInterval === 100">
              <input type="radio" name="rpChainageInterval" [value]="100"
                     [checked]="rpChainageInterval === 100" (change)="rpChainageInterval = 100"> 100m
            </label>
            <label class="rp-radio-pill" [class.active]="rpChainageInterval === 200">
              <input type="radio" name="rpChainageInterval" [value]="200"
                     [checked]="rpChainageInterval === 200" (change)="rpChainageInterval = 200"> 200m
            </label>
          </div>
        </div>
        <button class="rp-action-btn" (click)="rpGenerateChainage()">&#9898; Generate</button>
      </div>

      <!-- Cross-Sections Section -->
      <div class="rp-right-subheader">
        <h4 class="rp-sub-title">Cross-Sections</h4>
      </div>
      <div class="rp-detail-section">
        <div class="rp-xsection-item" *ngFor="let cs of rpCrossSections; let i = index">
          <span class="rp-xs-status">&#10004;</span>
          <span class="rp-xs-id">CS-{{ (i + 1) | number:'3.0-0' }}</span>
          <span class="rp-xs-ch">{{ cs.chainage }}</span>
          <button class="rp-xs-jump" (click)="rpJumpToCrossSection(i)">&#9678;</button>
          <button class="rp-xs-del" (click)="rpDeleteCrossSection(i)">&#10005;</button>
        </div>
        <div *ngIf="rpCrossSections.length === 0" class="rp-empty-msg">No cross-sections placed</div>
        <button class="rp-action-btn" (click)="rpSetTool('xsection')">&#10010; Add New</button>
      </div>

      <!-- Legend -->
      <div class="rp-right-subheader">
        <h4 class="rp-sub-title">Legend</h4>
      </div>
      <div class="rp-detail-section rp-legend">
        <div class="rp-legend-row"><span class="rp-lg-sw" style="background:#000"></span> Carriageway</div>
        <div class="rp-legend-row"><span class="rp-lg-sw" style="background:#8B4513; opacity:0.6"></span> Shoulder</div>
        <div class="rp-legend-row"><span class="rp-lg-sw rp-lg-hatched"></span> Separator</div>
        <div class="rp-legend-row"><span class="rp-lg-sw" style="background:#ADD8E6; opacity:0.6; border:1px dashed #4682B4"></span> ROW Boundary</div>
        <div class="rp-legend-row"><span class="rp-lg-sw rp-lg-circle"></span> Chainage</div>
        <div class="rp-legend-row"><span class="rp-lg-sw" style="background:#FF0000"></span> X-Section</div>
      </div>
    </div>

    <!-- Right Panel Toggle (when hidden) -->
    <button class="rp-right-toggle" *ngIf="!rpRightPanelVisible"
            (click)="rpRightPanelVisible = true">&#10094; Properties</button>
  </div>

  <!-- RP Bottom Status Bar (matching reference footer) -->
  <div class="rp-statusbar">
    <div class="rp-sb-left">
      <span class="rp-sb-item">&#128205; Lat: 19.1234</span>
      <span class="rp-sb-item">Lon: 72.9876</span>
    </div>
    <div class="rp-sb-center">
      <span class="rp-sb-item">&#9939; Chainage: {{ rpSelectedRoadIndex >= 0 ? '120+750' : '--' }}</span>
      <span class="rp-sb-item">&#9968; Elevation: 85 m</span>
    </div>
    <div class="rp-sb-right">
      <span class="rp-sb-item">&#128208; Scale: {{ rpScaleText }}</span>
      <span class="rp-sb-item">Zoom: {{ rpZoomLevel }}</span>
      <span class="rp-sb-item rp-sb-conn" [class.rp-sb-offline]="!rpIsOnline">
        {{ rpIsOnline ? '&#128994; Online' : '&#128308; Offline' }}
      </span>
    </div>
  </div>
</div>
<!-- ======================== END ROAD PLANNING MODULE ======================== -->